var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.364C8.28 9.364 10 7.644 10 5.364C10 3.084 8.28 1.364 6 1.364C3.72 1.364 2 3.084 2 5.364C2 7.644 3.72 9.364 6 9.364ZM6 3.364C7.178 3.364 8 4.186 8 5.364C8 6.542 7.178 7.364 6 7.364C4.822 7.364 4 6.542 4 5.364C4 4.186 4.822 3.364 6 3.364ZM7 10.364H5C2.243 10.364 0 12.607 0 15.364V16.364H2V15.364C2 13.71 3.346 12.364 5 12.364H7C8.654 12.364 10 13.71 10 15.364V16.364H12V15.364C12 12.607 9.757 10.364 7 10.364ZM16.364 0L14.95 1.414C16.271 2.737 17 4.495 17 6.364C17 8.233 16.271 9.991 14.95 11.314L16.364 12.728C18.064 11.027 19 8.767 19 6.364C19 3.961 18.064 1.701 16.364 0Z",
    fill: "#2E2E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5351 2.828L12.1211 4.244C12.6881 4.809 13.0001 5.562 13.0001 6.364C13.0001 7.166 12.6881 7.919 12.1211 8.484L13.5351 9.9C14.4791 8.956 15.0001 7.701 15.0001 6.364C15.0001 5.027 14.4791 3.772 13.5351 2.828Z",
    fill: "#2E2E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRequest);
export default __webpack_public_path__ + "static/media/user-request.1357b2f9f9dff77a10a625bc83873d94.svg";
export { ForwardRef as ReactComponent };